import { isValidRecommendation } from './Recommendation';
export const recommendationApiToRecommendationEntity = recommendation => {
  if (!recommendation) {
    throw new Error('Invalid recommendationApi', {
      cause: {
        recommendation
      }
    });
  }
  const convertedRecommendation = {
    id: recommendation.id,
    revision: recommendation.revision,
    title: recommendation.recurrenceSuggestion
  };
  if (isValidRecommendation(convertedRecommendation)) {
    return convertedRecommendation;
  }
  throw new Error('Invalid recommendation data', {
    cause: {
      convertedRecommendation
    }
  });
};
//# sourceMappingURL=converters.js.map